// extracted by mini-css-extract-plugin
export default {"right":"Right_right__13SV3"};